// extracted by mini-css-extract-plugin
export var childrenContainer = "_4o-0";
export var virtualScrollArea = "_4o-1";